<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>
      <div class="header-logo">&nbsp;</div>
    </ion-title>
  </ion-toolbar>
</ion-header>


<ion-content no-bounce class="no-scroll ion-padding">
  <p translate class="pre">MODE.PRETEXT1</p>
  <p translate class="pre">MODE.PRETEXT2</p>
  <ion-radio-group [(ngModel)]="mode" (ionChange)="valueChanged()">
    <ion-card>
      <ion-card-content (click)="mode = 'simple'">
        <ion-grid>
          <ion-row>
            <ion-col size="8" class="mode_text">
              <ion-radio value="simple" labelPlacement="end" translate mode="md">MODE.SIMPLE.LABEL</ion-radio>
              <p translate>MODE.SIMPLE.SHORT_DESC</p>
            </ion-col>
            <ion-col size="4" class="img_simple">
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card-content>
      <ion-button class="more-info" fill="clear" expand="full" (click)="onMoreInfoClick('simple')" translate>
        MODE.MORE_INFO
        <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </ion-card>
    <ion-card>
      <ion-card-content (click)="mode = 'standard'">
        <ion-grid>
          <ion-row>
            <ion-col size="8" class="mode_text">
              <ion-radio value="standard" labelPlacement="end" translate mode="md">MODE.STANDARD.LABEL</ion-radio>
              <p translate>MODE.STANDARD.SHORT_DESC</p>
            </ion-col>
            <ion-col size="4" class="img_standard">
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card-content>
      <ion-button class="more-info" fill="clear" expand="full" (click)="onMoreInfoClick('standard')" translate>
        MODE.MORE_INFO
        <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </ion-card>
  </ion-radio-group>
</ion-content>
<ion-footer>
  <ion-button fill="solid" shape="round" expand="block" color="light" (click)="onNextClick()" [disabled]="mode == ''" translate>COMMON.NEXT</ion-button>
</ion-footer>
